<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-card class="pa-3">
            <v-card-title>
                <h2 class="title">Create Banner</h2>
            </v-card-title>

            <div v-if="loading" class="my-3 px-6">
                <v-progress-linear
                        :indeterminate="loading"
                        :class="{ 'no-opacity': !loading }"
                        style="height: 2px;"
                ></v-progress-linear>
            </div>
            <template v-else>
                <v-card-text class="mt-5">
                    <div>
                        <div class="px-2">
                            <!-- <div class="mb-4">
                                <div class="body-2">Advertiser Topics:</div>
                                <template v-if="!no_data.includes(topics) && topics.length > 0">
                                    <v-chip
                                    v-for="item in topics"
                                    :key="item.id"
                                    small
                                    class="my-1 mr-2"
                                    color="primary"
                                    >
                                    {{ decodeHTMLEntities(item.name) }}
                                    </v-chip>
                                </template>
                                <div v-else class="body-2 mb-3 grey--text">
                                    There are no selected topics for this advertiser.
                                </div>
                            </div> -->
                            <v-autocomplete
                                :items="topics"
                                label="Topics"
                                :item-text="i => decodeHTMLEntities(i.name)"
                                item-value="id"
                                multiple
                                class="mb-3"
                                v-model="preparedData.category_ids"
                                placeholder="Please Select"
                                :error-messages="errors($v.preparedData.category_ids) || server_errors.category_ids"
                                @focus="resetServerValidation"
                            ></v-autocomplete>
                            <v-autocomplete
                                :items="bannerTypes"
                                label="Type"
                                :item-text="item => `${item.name} (${item.width}x${item.height})`"
                                item-value="id"
                                class="mb-3"
                                v-model="preparedData.banner_type_id"
                                placeholder="Please Select"
                                :error-messages="errors($v.preparedData.banner_type_id) || server_errors.banner_type_id"
                                @focus="resetServerValidation"
                            ></v-autocomplete>
                            <v-text-field
                                v-model="preparedData.url"
                                name="url"
                                id="url"
                                label="URL"
                                hint="URL needs to be in https://www.website.com format"
                                persistent-hint
                                placeholder="Please Enter"
                                :error-messages="errors($v.preparedData.url) || server_errors.url"
                                @focus="resetServerValidation"
                            ></v-text-field>
                            <v-text-field
                                v-model="preparedData.alt_text"
                                class="mt-3"
                                name="alt_text"
                                id="alt_text"
                                label="Alternative Text"
                                placeholder="Please Enter"
                                :error-messages="errors($v.preparedData.alt_text) || server_errors.alt_text"
                                @focus="resetServerValidation"
                            ></v-text-field>
                            <v-file-input
                                id="image"
                                accept="image/png, image/jpeg, image/jpg, image/gif"
                                ref="file"
                                name="image"
                                show-size
                                label="Banner"
                                placeholder="Please Select"
                                v-model="preparedData.image"
                                :error-messages="errors($v.preparedData.image) || imageSizeErrors || server_errors.image"
                                @change="handleFileUploads"
                            ></v-file-input>
                            <v-checkbox
                                v-if="!no_data.includes(organization) && Boolean(organization.global)"
                                v-model="preparedData.global"
                                label="Global"
                                :error-messages="server_errors.global"
                                @focus="resetServerValidation"
                            ></v-checkbox>
                        </div>
                        <v-alert class="pa-2 mt-6" :value="$v.$error || imageSizeErrors.length > 0" outlined color="error" icon="mdi-alert" transition="scale-transition">
                            <span class="caption">Please fill out form correctly</span>
                        </v-alert>
                        <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert"
                                 transition="scale-transition">
                            <span class="caption">{{ serverValidationMessage }}</span>
                        </v-alert>
                    </div>
                </v-card-text>

                <v-card-actions class="px-6">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
                    <v-btn
                        color="primary"
                        :disabled="loadingSave"
                        :loading="loadingSave"
                        @click="CreateBanner"
                    >Save
                    </v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
    import ApiService from "@/common/api.service";
    import { validationMixin } from "vuelidate"
    import { required, url } from "vuelidate/lib/validators"
    import { valMessages, getValMessage } from "@/common/error-messages"

    let validations = {}

    export default {
        name: 'CreateBanner',
        mixins: [validationMixin],
        validations() {
            validations = {
                preparedData: {
                    category_ids: {},
                    banner_type_id: { required },
                    url: { required, url },
                    alt_text: { required, url },
                    image: { required }
                }
            }
            if(!Boolean(this.preparedData.global)) {
                validations.preparedData.category_ids.required = required
            }
            this.errors = getValMessage(valMessages)(validations)
            return validations
        },
        data: () => ({
            no_data: [null, "", undefined, "null"],
            item: null,
            preparedData: {},
            bannerTypes: [],
            topics: [],
            loading: false,
            loadingSave: false,
            loadingAdvertiser: false,
            loadingBannerTypes: false,
            organization: {},
            dialog: false,
            file: null,
            selectedFileHeight: null,
            selectedFileWidth: null,
            serverValidation: true,
            serverValidationMessage: "Oops something went wrong...",
            server_errors: {}
        }),
        mounted() {
            this.$root.$on('CreateBanner', this.openModal)
        },
        beforeDestroy() {
            this.$root.$off('CreateBanner', this.openModal)
        },
        methods: {
            getAdvertiserDetails () {
                this.loadingAdvertiser = true;
                return new Promise((resolve, reject) => {
                    ApiService.get(`/admin/organization/${this.$route.params.organization_id}/show`)
                    .then(response => {
                        this.organization = response.data.organization
                        this.loadingAdvertiser = false
                        resolve();
                    })
                    .catch(({ response }) => {
                        this.loadingAdvertiser = false
                        this.serverValidation = false;
                        if (response.data.error) {
                        this.serverValidationMessage = this.titleCase(
                            response.data.error
                        );
                        }
                        reject();
                    });
                });
            },
            getBannerTypes() {
                this.loadingBannerTypes = true;
                return new Promise((resolve, reject) => {
                    ApiService.get("/banner_types", {organization_id: this.organization_id})
                        .then(response => {
                            let data = response.data;
                            this.bannerTypes = data.banner_types
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.loadingBannerTypes = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            openModal(topics) {
                this.resetServerValidation()
                this.preparedData = {}
                this.topics = topics
                this.file = null
                this.loading = true
                this.$v.$reset()
                this.dialog = true
                Promise.all([this.getBannerTypes(), this.getAdvertiserDetails()])
                    .then(values => {
                        this.loading = false
                    })
                    .catch(error => {
                        this.resetServerValidation();
                        this.loading = false
                    });
            },
            CreateBanner() {
                this.resetServerValidation()
                this.$v.preparedData.$touch()
                if (!this.$v.preparedData.$invalid && this.imageSizeErrors.length === 0) {
                    this.loadingSave = true

                    const formData = {
                        category_ids: this.preparedData.category_ids,
                        banner_type_id: this.preparedData.banner_type_id,
                        url: this.preparedData.url,
                        alt_text: this.preparedData.alt_text,
                        image: this.file,
                        organization_id: this.$route.params.organization_id
                    }

                    if(!this.no_data.includes(this.preparedData.global)) {
                        formData.global = this.preparedData.global
                    }

                    ApiService.put('/admin/banner', formData)
                        .then(response => {
                            this.$root.$emit("notification", {
                                status: "success",
                                text: `Banner has been successfully created`
                            });
                            this.loadingSave = false
                            this.$emit('done')
                            this.closeModal()
                        })
                        .catch(({response}) => {
                            this.loadingSave = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            if (response.data.message) {
                                this.serverValidationMessage = response.data.message;
                            }
                            if (response.data.errors) {
                                this.server_errors = response.data.errors;
                            }
                        });
                    }
            },
            closeModal() {
                this.dialog = false
            },
            titleCase(str) {
                return _.startCase(str.replace(/_/g, " "));
            },
            handleFileUploads(event) {
                if(event) {
                    let image = event;

                    let imageFile = new Image()

                    let reader = new FileReader();
                    reader.readAsDataURL(image);
                    reader.onload = e => {
                        this.file = e.target.result
                        imageFile.src = e.target.result
                    }

                    imageFile.onload = () => {
                        this.selectedFileHeight = imageFile.height
                        this.selectedFileWidth = imageFile.width
                    };
                } else {
                    this.file = null,
                    this.selectedFileHeight = null,
                    this.selectedFileWidth = null,
                    delete this.preparedData.image
                }
            },
            decodeHTMLEntities(i) {
                return _.unescape(i)
            },
            resetServerValidation() {
                this.serverValidation = true;
                this.serverValidationMessage = "Oops something went wrong...";
                this.server_errors = {};
            },
            errors: getValMessage(valMessages)(validations)
        },
        computed: {
            imageSizeErrors: function () {
                if (this.preparedData.banner_type_id && this.file && this.selectedFileHeight && this.selectedFileWidth) {
                    let bannerType = this.bannerTypes.find(i => i.id === this.preparedData.banner_type_id)
                    if (this.selectedFileHeight !== Number(bannerType.height) || this.selectedFileWidth !== Number(bannerType.width)) {
                        return [`Image dimensions need to be ${bannerType.width}x${bannerType.height} (WxH)`]
                    } else {
                        return []
                    }
                } else {
                    return []
                }
            }
        }
    }
</script>
